import { render, staticRenderFns } from "./ahEInvoicePlatformLabel.vue?vue&type=template&id=cd5f36ba&scoped=true&"
import script from "./ahEInvoicePlatformLabel.vue?vue&type=script&lang=js&"
export * from "./ahEInvoicePlatformLabel.vue?vue&type=script&lang=js&"
import style0 from "./ahEInvoicePlatformLabel.vue?vue&type=style&index=0&id=cd5f36ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f36ba",
  null
  
)

export default component.exports